// @ts-nocheck
import { useGLTF, useTexture, Plane, Box, Svg } from '@react-three/drei'
import React, { useRef } from 'react'
import * as THREE from 'three'

const texture1 = `${process.env.PUBLIC_URL}/assets/images/glasses/page2a-frame.png`;
const svg2 = `${process.env.PUBLIC_URL}/assets/images/glasses/page2a-arm.svg`;


export default function Model(props) {
  const group = useRef()
  const bodyTex  = useTexture(texture1)

  return (
    <group ref={group} {...props} dispose={null} position-y={-0.04} scale={0.9}>

      <Svg src={svg2} scale={.001} position={[-1.4,0.76,-1.95]} rotation={[0, -Math.PI/2, 0]}/>
      <Svg src={svg2} scale={.001} position={[1.4,0.76,-1.95]} rotation={[0, -Math.PI/2, 0]}/>


      <Plane args={[3.275, 1.425]} 
      position={[0,.4,0]}
      >
         <meshBasicMaterial  map={bodyTex} side={THREE.DoubleSide} alphaTest={0.1}
         transparent 
         />
      </Plane>
      {/*
      <Plane args={[2.275, 0.705]} 
      position={[-1.4,0.45,-1.15]} 
      rotation={[0, -Math.PI/2, 0]}>
         <meshBasicMaterial transparent map={armTex} side={THREE.DoubleSide} alphaTest={0.1} />
      </Plane>
      <Plane args={[2.275, 0.705]}  
      position={[1.4,0.45,-1.15]} 
      rotation={[0, -Math.PI/2, 0]}>
         <meshBasicMaterial transparent map={armTex} side={THREE.DoubleSide} alphaTest={0.1} />
      </Plane>
  */}
     

    </group>
  )
}

